import { Button, Divider, Input, Modal, notification } from 'antd';

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

import '../../assets/css/social_media_modal.css';
import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { usePreventScroll } from '../../../../utils/hooks';

function SocialMediaShareButton({ name, icon, colour = '#ffffff' }) {
  return (
    <div className={'social_media_modal__button'}>
      <div
        className={'social_media_modal__button__icon'}
        style={{ backgroundColor: colour }}
      >
        {icon}
      </div>
      <p className={'social_media_modal__button__name gRegular'}>{name}</p>
    </div>
  );
}

export default function SocialMediaShareModal({
  url,
  pageTitle,
  isOpen = false,
  setIsOpen,
}) {
  const iconSize = 32;

  // Prevent background app scroll when modal is open
  usePreventScroll('SocialMediaShareModal', isOpen);

  const shareButtons = [
    {
      name: 'Facebook',
      icon: FacebookIcon,
      colour: '#b3c2e0',
      shareButton: {
        type: FacebookShareButton,
        props: { url, quote: pageTitle },
      },
    },
    {
      name: 'Twitter',
      icon: TwitterIcon,
      colour: '#bbe3fb',
      shareButton: {
        type: TwitterShareButton,
        props: { url, title: pageTitle },
      },
    },
    {
      name: 'WhatsApp',
      icon: WhatsappIcon,
      colour: '#bef2d1',
      shareButton: {
        type: WhatsappShareButton,
        props: { url, title: pageTitle },
      },
    },
    {
      name: 'Email',
      icon: EmailIcon,
      colour: '#e5e5e5',
      shareButton: {
        type: EmailShareButton,
        props: { url, subject: pageTitle, body: 'Check out the profile at ' },
      },
    },
    {
      name: 'Reddit',
      icon: RedditIcon,
      colour: '#ffcdb3',
      shareButton: {
        type: RedditShareButton,
        props: { url, title: pageTitle },
      },
    },
    {
      name: 'Telegram',
      icon: TelegramIcon,
      colour: '#d3ecf7',
      shareButton: {
        type: TelegramShareButton,
        props: { url, title: pageTitle },
      },
    },
  ];

  return (
    <Modal
      title={'Share'}
      className={'social_media_modal'}
      footer={null}
      centered
      width={'30rem'}
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
      }}
    >
      <div className={'social_media_modal__buttons'}>
        {shareButtons.map((link) => {
          const ShareButton = link.shareButton.type;
          const Icon = link.icon;
          return (
            <ShareButton {...link.shareButton.props} key={link.name}>
              <SocialMediaShareButton
                name={link.name}
                icon={<Icon size={iconSize} />}
                colour={link.colour}
              />
            </ShareButton>
          );
        })}
      </div>
      <Divider style={{ marginTop: '0.5rem', marginBottom: '1rem' }} />
      <div className={'social_media_modal__section mg-bottom-10'}>
        <h2 className={'gSemiBold fs-18'}>Page Link</h2>
        <Input.Group compact className={'social_media_modal__copy_control'}>
          <Input
            disabled
            value={url}
            style={{ width: 'calc(100% - 2rem)' }}
            prefix={<LinkOutlined />}
          />
          <Button
            icon={<CopyOutlined />}
            onClick={() => {
              navigator.clipboard.writeText(url);
              notification.open({
                duration: 1.5,
                description: 'Link copied to clipboard.',
              });
            }}
          />
        </Input.Group>
      </div>
    </Modal>
  );
}
